import { Permissions, useAuthenticationService } from '../authentication/authentication-service';

export const useCanEditEmployee = () => {
  const permission = useAuthenticationService(state => state.user?.profile.permission);
  const canEdit = permission?.includes(Permissions.EmployeeUpdate) ?? false;

  return canEdit;
};
